import { Button, Form, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getAllCountry } from "../../../redux/rtk/features/masters/countrySlice";
import { getAllState } from "../../../redux/rtk/features/masters/stateSlice";
import { loadSingleStaff, updateUser } from "../../../redux/rtk/features/user/userSlice";
import BtnEditSvg from "../Button/btnEditSvg";

const AddressEditPopup = ({ userId, user }) => {
    const Option = Select;
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { id } = useParams();
    const state = useSelector((state) => state.state?.list);
    const country = useSelector((state) => state.country?.list);

    useEffect(() => {

        dispatch(getAllState())
        dispatch(getAllCountry())

    }, []);

    useEffect(() => {
        if (isModalOpen) {
            console.log("Setting form values:", user);
            form.setFieldsValue({
                street: user?.street || "",
                city: user?.city || "",
                state: user?.state || "",
                zipCode: user?.zipCode || "",
                country: user?.country || "",
                pAddress: user?.pAddress || "",
                pCity: user?.pCity || "",
                pState: user?.pState || "",
                pZipCode: user?.pZipCode || "",
                pCountry: user?.pCountry || "",
            });
        }
    }, [isModalOpen, user, form]);



    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        form.resetFields();
    };

    const onFinish = async (values) => {
        try {
            const updateValues = {

                street: values.street,
                city: values.city,
                state: values.state,
                zipCode: values.zipCode,
                country: values.country,


                pAddress: values.pAddress,
                pCity: values.pCity,
                pState: values.pState,
                pZipCode: values.pZipCode,
                pCountry: values.pCountry

            };

            console.log("Sending Update:", updateValues);

            const response = await dispatch(updateUser({ id: userId, values: updateValues }));
            console.log("API Response:", response);

            if (response.payload?.message === "success") {
                await dispatch(loadSingleStaff(id));
                console.log("Reloaded user data");
                setIsModalOpen(false);
                form.resetFields();
            } else {
                console.error("Update failed:", response.payload);
            }
        } catch (error) {
            console.error("Error updating address details:", error);
        }
    };



    return (
        <>
            <button onClick={showModal} aria-label="Edit Address Details">
                <BtnEditSvg size={30} />
            </button>
            <Modal
                title="Update Address Details"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={null}
                width={600}
            >
                <Form
                    form={form}
                    name="addressDetails"
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <div className="mb-4">
                        <h3 className="text-lg font-semibold mb-2">Current Address</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                label="Address"
                                name="street"
                                className="mb-2"
                            >
                                <Input placeholder="Enter street" />
                            </Form.Item>

                            <Form.Item
                                label="City"
                                name="city"
                                className="mb-2"
                            >
                                <Input placeholder="Enter city" />
                            </Form.Item>

                            {/* <Form.Item
                                label='City'
                                name='state'
                            // rules={[{ required: true, message: "Please select a state!" }]}
                            >
                                <Select placeholder="Select a city" showSearch allowClear>
                                    {state &&
                                        state.map((state) => (
                                            <Option key={state.id} value={state.id}>
                                                {state.stateName}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item> */}

                            <Form.Item
                                label="Post Code"
                                name="zipCode"
                                className="mb-2"
                            >
                                <Input placeholder="Enter post code" />
                            </Form.Item>

                            {/* <Form.Item
                                label='Country'
                                name='country'
                            // rules={[{ required: true, message: "Please select a country!" }]}
                            >
                                <Select placeholder="Select a country" showSearch allowClear>
                                    {country &&
                                        country.map((country) => (
                                            <Option key={country.id} value={country.id}>
                                                {country.countryName}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item> */}
                             <Form.Item
                                label='Country'
                                name='country'
                            // rules={[{ required: true, message: "Please select a country!" }]}
                            >
                                <Input placeholder="Country"></Input>
                            </Form.Item>
                        </div>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-2">Permanent Address</h3>
                        <div className="grid grid-cols-2 gap-4">
                            <Form.Item
                                label="Address"
                                name="pAddress"
                                className="mb-2"
                            >
                                <Input placeholder="Enter permanent address" />
                            </Form.Item>

                            <Form.Item
                                label="City"
                                name="pCity"
                                className="mb-2"
                            >
                                <Input placeholder="Enter permanent city" />
                            </Form.Item>

                            {/* <Form.Item
                                label='City'
                                name='pState'
                            // rules={[{ required: true, message: "Please select a state!" }]}
                            >
                                <Select placeholder="Select a city" showSearch allowClear>
                                    {state &&
                                        state.map((state) => (
                                            <Option key={state.id} value={state.id}>
                                                {state.stateName}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item> */}

                            <Form.Item
                                label="Post Code"
                                name="pZipCode"
                                className="mb-2"
                            >
                                <Input placeholder="Enter permanent post code" />
                            </Form.Item>

                            {/* <Form.Item
                                label='Country'
                                name='pCountry'
                            // rules={[{ required: true, message: "Please select a country!" }]}
                            >
                                <Select placeholder="Select a country" showSearch allowClear>
                                    {country &&
                                        country.map((country) => (
                                            <Option key={country.id} value={country.id}>
                                                {country.countryName}
                                            </Option>
                                        ))}
                                </Select>
                            </Form.Item> */}
                            <Form.Item
                                label='Country'
                                name='pCountry'
                            // rules={[{ required: true, message: "Please select a country!" }]}
                            >
                                <Input placeholder="Country"></Input>
                            </Form.Item>
                        </div>
                    </div>

                    <Form.Item className="mt-4">
                        <Button type="primary" htmlType="submit">
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default AddressEditPopup;